import axios from "../http";
let module = "/sys";
function login(data){
  return axios.post(module +'/login',data);
}

function logout(){
  return axios.post(module +'/logout');
}

function getUserInfo(){
  return axios.post(module +'/u');
}

export default {
  login,
  logout,
  getUserInfo,
}



// WEBPACK FOOTER //
// ./src/api/modules/sys.js